module.exports = __webpack_public_path__ + "static/media/helst-l.c10e68b3.mp3";